import LocationUpdate from './LocationUpdate'
export {LocationUpdate}
export default LocationUpdate
